const InitializeState = {
  appReducer: {
    changed: false,
    showWarringChangeMessage: false,
    callback: null,
    breadcrumb: ["Overview"],
    expandChart: {
      show: false,
      data: {},
      title: "Chart",
    },
    globalSetting: null,
  },
  authReducer: { user: null, isLoggedIn: false },
};

const KEY = "oa-app-state";
class StateLoader {
  loadState() {
    try {
      let serializedState = localStorage.getItem(KEY);
      console.log("serializedState: ", serializedState);
      if (serializedState === null) {
        return this.initializeState();
      }

      return JSON.parse(serializedState);
    } catch (err) {
      return this.initializeState();
    }
  }

  loadStateByReducer(reducerName) {
    try {
      let serializedState = localStorage.getItem(KEY);

      if (serializedState === null) {
        return this.initializeState()[reducerName];
      }

      return JSON.parse(serializedState)[reducerName];
    } catch (err) {
      console.log(err);
      return this.initializeState()[reducerName];
    }
  }

  saveState(state) {
    try {
      let serializedState = JSON.stringify(state);
      localStorage.setItem(KEY, serializedState);
    } catch (err) {}
  }

  initializeState() {
    return InitializeState;
  }
}

export default StateLoader;
